import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { SessionProvider } from './Components/sessionProvider';
import  Landing  from './Pages/landing';
import { prepareDatabaseV1 } from './Api/DevDatabase'

function App() {
    // APIProvider db= "URL" for production
    return (
        <CookiesProvider>
            <SessionProvider cookie_name='dpp_session'>
                <Landing/>
            </SessionProvider>
        </CookiesProvider>
    );
}

export default App;

